import { Trans } from '@lingui/macro';
import React, { useContext } from 'react';
import { Navigate, useNavigate } from 'react-router-dom';
import { Button, Row, Col, Container } from 'reactstrap';
import { AuthContext } from '../context/AuthContext';
import FormComponent from '../components/FormComponent';
import { Logo } from '../components/_general/Logo'
import ExternalLayout from '../components/layouts/ExternalLayout';
import "../scss/_login.scss"

const LoginForm = FormComponent({
    displayName: 'Login',
    schema: {
        title: "Login",
        type: "object",
        properties: {
            email: { title: "Email", type: "string" },
            password: { title: "Password", type: "string" },
        },
        required: ["email", "password"],
    },
    uiSchema: {
        "password": { "ui:widget": "password" },
    },
    parseProps: () => ({
        auth: useContext(AuthContext),
    }),
    async onSubmit({ formData: { email, password } }, { props: { auth } }) {
        await auth.login({ email, password });
    },
    renderFormChildren: ({ navigate }) => {
        function forgotPassword() { navigate("/forgot-password") }

        return (<>
            <Row>
                <Col>
                    <Button color="primary" type="submit" data-cy="submit" block>
                        <Trans>Login</Trans>
                    </Button>
                </Col>
                <Col><Button color="link" onClick={forgotPassword} block>Forgot my password</Button></Col>
            </Row>
            <hr />

            <div className="text-center">
                <h5 className="text-bold"><Trans>Need to create an account?</Trans></h5>
                <p className="text"><Trans>Get in touch with a system administrator</Trans></p>
                {/* <Button color="primary" outline onClick={signUp} block>Registrarme</Button> */}
            </div>
        </>);
    },
    renderFormSubmitted: () => (
        <Navigate to="/" replace />
    ),
    withoutNavigation: true
});

const Login = () => {
    const navigate = useNavigate();
    return (
        <ExternalLayout>
            <div className="login-logo">
                <img src="windmar-logo.svg" alt="logo" />
            </div>
            <div className="div-login" >
                <LoginForm navigate={navigate} />
            </div>
        </ExternalLayout>
    )
};


export default Login;